module.exports = __webpack_public_path__ + "static/media/job mtach score -1-review your result.4b65edce.png";